export default __webpack_public_path__ + "images/3390c52c52472ee4abd6a2e3552882ba-parents_association_small.webp";